export default __webpack_public_path__ + "static/media/ups-icon.9d1a4e5b.svg";